import * as types from "./UserRights.actionTypes"


export const getUserRightsDetails=(payload)=>{
  return {
    type:types.USER_RIGHTS,
    payload:payload
  }
}